<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2 v-if="myself">{{myself.firstname + ' ' + myself.lastname}}</h2> -->
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">
        <p class="error-label" v-if="message">{{message}}</p>
        <div v-if="myself" class="info-grid">

            <section class="info-card">
                <h3 class="info-card__title">Información personal</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Nombre</dt>
                        <dd>{{ fullName }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Correo</dt>
                        <dd>{{ myself.username || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Login</dt>
                        <dd>{{ myself.login || 'No hay dato' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Región</dt>
                        <dd>{{ myself.region || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Cargo</dt>
                        <dd>{{ myself.cargo || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Teléfono</dt>
                        <dd>{{ myself.telefono || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Género</dt>
                        <dd>{{ myself.genero || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Tipo de usuario</dt>
                        <dd>{{ myself.es_externo ? 'Externo' : 'Interno' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Institución</dt>
                        <dd>{{ myself.institucion || '—' }}</dd>
                    </div>
                </dl>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">Cuenta</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Fecha de creación</dt>
                        <dd>{{ dateFormatter(myself.created_at) }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Último acceso</dt>
                        <dd>{{ myself.last_login ? dateTimeFormatter(myself.last_login) : '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Estado</dt>
                        <dd>
                            <span class="badge" :class="myself.status === false ? 'badge--off' : 'badge--on'">
                                {{ myself.status === false ? 'Inactiva' : 'Activa' }}
                            </span>
                        </dd>
                    </div>
                </dl>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">Permisos</h3>
                <div class="chip-row">
                    <span
                    v-for="perm in permissionItems"
                    :key="perm.label"
                    class="chip"
                    :class="perm.granted ? 'chip--on' : 'chip--off'"
                    >
                        <font-awesome-icon v-if="perm.granted" icon="check" class="chip__icon"></font-awesome-icon>
                        {{ perm.label }}
                    </span>
                </div>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Grupos
                    <span v-if="myGroups.length" class="maps-count">{{ myGroups.length }}</span>
                </h3>
                <p v-if="groupsError" class="maps-empty">No fue posible cargar los grupos.</p>
                <p v-else-if="!myGroups.length" class="maps-empty">Sin grupos asignados</p>
                <div v-else class="chip-row">
                    <span v-for="group in myGroups" :key="group.id" class="chip chip--tag">
                        <font-awesome-icon icon="users" class="chip__icon"></font-awesome-icon>
                        {{ group.name }}
                    </span>
                </div>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">
                    Mapas asignados
                    <span v-if="canUseVisor && mapsAssignedToUserID.length" class="maps-count">{{ mapsAssignedToUserID.length }}</span>
                </h3>
                <p v-if="!canUseVisor" class="maps-empty">Tu cuenta no tiene acceso al visor</p>
                <p v-else-if="!mapsAssignedToUserID.length" class="maps-empty">Sin mapas asignados</p>
                <ul v-else class="maps-list">
                    <li v-for="item in mapsAssignedToUserID" :key="item.id">
                        <router-link class="maps-list__item" :to="'/visor/' + item.id">
                            <font-awesome-icon icon="map" class="maps-list__icon"></font-awesome-icon>
                            <span class="maps-list__name">{{ item.name }}</span>
                            <span class="maps-list__go" aria-hidden="true">›</span>
                        </router-link>
                    </li>
                </ul>
            </section>

        </div>
    </div>

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

</main>
</template>

<style scoped lang="scss">
// Los estilos del sistema info-card/chips/maps-list viven en assets/style/style.scss

// El .error-label global es position:absolute y taparía la primera tarjeta;
// acá se hace fluir en el layout
.error-label {
    position: static;
    margin: 0 0 1rem;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    color: var(--color-danger);
}
</style>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {restVisor} from '@/components/mixin/restVisor.js'

export default{
    name: 'test',
    mixins: [formatter, restVisor],
    data(){
        return{
            myself: null,
            myGroups: [],
            message: null,
            groupsError: false
        }
    },
    components:{
        Breadcrumb,
        SideNav,
        TabNav
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Cuenta' }
              ]
        },
        routesNav: function(){
          return [
                {name:'Cuenta', path: '/cuenta/mi-cuenta'},
                {name:'Cambiar contraseña' , path: '/cuenta/cambiar-contrasena'},
              ]
        },
        fullName: function(){
            if(!this.myself) return '—';
            var name = ((this.myself.firstname || '') + ' ' + (this.myself.lastname || '')).trim();
            return name.length ? name : '—';
        },
        permissionItems: function(){
            var permissions = (this.myself && this.myself.permissions) || {};
            return [
                {label: 'Usuarios', granted: !!permissions.users},
                {label: 'Capas', granted: !!permissions.layers},
                {label: 'Geoprocesos', granted: !!permissions.geo},
                {label: 'Mapas', granted: !!permissions.maps},
                {label: 'Visor', granted: !!permissions.visor},
                {label: 'Monitoreo', granted: !!permissions.monitoring},
                {label: 'Anotaciones', granted: !!permissions.annotation},
                {label: 'Documentos', granted: !!permissions.documents},
            ];
        },
        canUseVisor() {
            var permissions = this.$store.getters.getPermissions;
            return !!(permissions && permissions.visor);
        },
    },
    props: [],
    methods:{
        getMyself: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/accounts/me')
            .then(function (response) {
                that.myself = response.data;
                that.getMyGroups();
            })
            .catch(function (error) {
                console.log(error)
                //Fallas de red no traen error.response
                that.message = (error.response && error.response.data && error.response.data.message) || 'No fue posible cargar la información de la cuenta.';
            });
        },
        getMyGroups: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/accounts/me/groups')
            .then(function (response) {
                that.myGroups = response.data;
            })
            .catch(function (error) {
                console.log(error)
                //Distingue el error de carga del estado vacío legítimo en la sección Grupos
                that.groupsError = true;
                //Fallas de red no traen error.response
                that.message = (error.response && error.response.data && error.response.data.message) || 'No fue posible cargar los grupos.';
            });
        },
    },
    updated () {

    },
    created () {
        //Verificar permisos: basta con tener sesión iniciada. Ver la propia cuenta no
        //depende del permiso de visor, y exigirlo dejaba fuera a quien administra
        //usuarios o capas aunque el menú sí le ofrezca "Cuenta".
        this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    },
    mounted () {
        this.getMyself();
        //Los mapas asignados salen de un endpoint con permiso de visor. Pedirlos sin
        //ese permiso devuelve 401 y dejaba un error en la ficha, cuando en realidad
        //no hay nada que cargar: esa cuenta no entra al visor.
        if (this.canUseVisor) {
            this.getMapsAssigned();
        }
    }
}
</script>
